import React, { useState } from 'react';
import { SEO } from '../components/SEO';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faCircleExclamation, faPaperPlane, faSpinner, faCheckCircle, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await fetch('/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      if (response.ok) setSuccess(true);
      else {
        const data = await response.json();
        setError(data.message || 'Failed to send reset email');
      }
    } catch { setError('Network error. Please try again.'); }
    finally { setLoading(false); }
  };

  return (
    <>
      <SEO title="Forgot Password | GHLWA" canonical="https://app.ghlwa.com/forgot-password" />
      <div className="min-h-screen flex">
        <div className="auth-left-panel">
          <div className="absolute top-[-80px] right-[-80px] w-72 h-72 rounded-full opacity-10" style={{ background: '#6366f1' }} />
          <div className="absolute bottom-[-60px] left-[-60px] w-56 h-56 rounded-full opacity-10" style={{ background: '#f59e0b' }} />
          <div className="relative z-10 flex flex-col items-center text-center">
            <img src="/ghlwa.png" alt="GHLWA Logo" className="h-24 w-auto mb-8 drop-shadow-xl" />
            <h1 className="text-4xl font-extrabold text-white mb-3 tracking-tight">GHLWA</h1>
            <p className="text-indigo-200 text-lg max-w-xs leading-relaxed">
              Seamless WhatsApp messaging for your GHL locations
            </p>
          </div>
        </div>
        <div className="auth-right-panel">
          <div className="w-full max-w-md">
            <div className="flex justify-center mb-8 lg:hidden">
              <img src="/ghlwa.png" alt="GHLWA" className="h-16 w-auto" />
            </div>
            {success ? (
              <div className="text-center">
                <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-5">
                  <FontAwesomeIcon icon={faCheckCircle} className="text-primary-600 text-3xl" />
                </div>
                <h2 className="text-2xl font-bold text-secondary-900 mb-3">Check your email</h2>
                <p className="text-secondary-500 mb-6">
                  We sent a password reset link to <span className="font-semibold text-secondary-700">{email}</span>
                </p>
                <a href="/login" className="btn-primary inline-flex items-center gap-2">
                  <FontAwesomeIcon icon={faArrowLeft} /> Back to login
                </a>
              </div>
            ) : (
              <>
                <h2 className="text-3xl font-extrabold text-secondary-900 mb-2">Forgot password?</h2>
                <p className="text-secondary-500 mb-8">Enter your email and we'll send you a reset link.</p>
                {error && (
                  <div className="mb-5 flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl text-sm">
                    <FontAwesomeIcon icon={faCircleExclamation} />{error}
                  </div>
                )}
                <form className="space-y-5" onSubmit={handleSubmit}>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-secondary-700 mb-1.5">Email address</label>
                    <div className="relative">
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3.5 text-secondary-400 pointer-events-none">
                        <FontAwesomeIcon icon={faEnvelope} className="text-sm" />
                      </span>
                      <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-field pl-10" placeholder="you@example.com" />
                    </div>
                  </div>
                  <button type="submit" disabled={loading} className="btn-primary w-full flex items-center justify-center gap-2 py-3 text-base disabled:opacity-50">
                    {loading ? (<><FontAwesomeIcon icon={faSpinner} className="animate-spin" /> Sending...</>) : (<><FontAwesomeIcon icon={faPaperPlane} /> Send reset link</>)}
                  </button>
                </form>
                <p className="mt-6 text-center text-sm text-secondary-600">
                  <a href="/login" className="font-semibold text-primary-600 hover:text-primary-700 transition-colors inline-flex items-center gap-1">
                    <FontAwesomeIcon icon={faArrowLeft} className="text-xs" /> Back to login
                  </a>
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
